import { render, staticRenderFns } from "./VoteListComponent.vue?vue&type=template&id=1af72ffc&scoped=true"
import script from "./VoteListComponent.vue?vue&type=script&lang=js"
export * from "./VoteListComponent.vue?vue&type=script&lang=js"
import style0 from "./VoteListComponent.vue?vue&type=style&index=0&id=1af72ffc&prod&lang=css"
import style1 from "./VoteListComponent.vue?vue&type=style&index=1&id=1af72ffc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af72ffc",
  null
  
)

export default component.exports